var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2106 4.48291H6.75153C6.04307 4.48291 5.4707 5.05528 5.4707 5.76374V35.2229C5.4707 35.9313 6.04307 36.5037 6.75153 36.5037H36.2106C36.9191 36.5037 37.4915 35.9313 37.4915 35.2229V5.76374C37.4915 5.05528 36.9191 4.48291 36.2106 4.48291ZM32.5122 13.829H29.9546C27.9493 13.829 27.561 14.7816 27.561 16.1825V19.2685H32.3481L31.7237 24.0996H27.561V36.5037H22.5698V24.1036H18.3951V19.2685H22.5698V15.7062C22.5698 11.5715 25.0954 9.31805 28.7858 9.31805C30.555 9.31805 32.072 9.45013 32.5163 9.51017V13.829H32.5122Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.20b529819ff43ff74cd08997bfcb3437.svg";
export { ForwardRef as ReactComponent };